export default (() => {
    const navToggles = Array.from(document.querySelectorAll('.js-nav-toggle'));
    const MobileMenu = document.querySelector('.MobileMenu');

    const updateAccessibilityAttrs = (active) => {
        navToggles.forEach((item) => (item.ariaExpanded = active ? 'true' : 'false'));
        if (!active) {
            setTimeout(() => MobileMenu.classList.add('invisible'), 800);
        } else {
            MobileMenu.classList.remove('invisible');
        }
    };

    navToggles.forEach((item) => {
        item.addEventListener('click', () => {
            MobileMenu.classList.toggle('toggled');
            const isActive = MobileMenu.classList.contains('toggled');
            document.body.classList.toggle('overflow-hidden');
            updateAccessibilityAttrs(isActive);

            const openAndShowContactSection = item.classList.contains('js-mobile-contact-toggle');
            const action = openAndShowContactSection ? 'add' : 'remove';
            document.querySelector('#nav-drawer-contact').classList[action]('toggled');
            document.querySelector('.MobileMenu__contact-icon').classList[action]('toggled');
        });
    });
})();
